/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../cart-service-apis/restClient';

const RESOURCE_ROOT_ADDRESSSERVICE = 'addressbook';
const RESOURCE_VERSION_ADDRESS = '/v2';
const RESOURCE_PAGE_ADDRESSSERVICE = '/occasions';
const RESOURCE_PAGE_ACTION = '/address';

const addAddressBookV2 = ({
    wcEnv, jwtToken, contactId, addressBookEntry,
}) => {
    const envObj = wcEnv || {};

    envObj.rootUri = `/${RESOURCE_ROOT_ADDRESSSERVICE}${RESOURCE_VERSION_ADDRESS}`;

    const resourcePage = `${RESOURCE_PAGE_ADDRESSSERVICE}/${contactId}${RESOURCE_PAGE_ACTION}`;
    return restClient.postRequest(wcEnv, resourcePage, jwtToken, addressBookEntry)
        .then((response) => response);
};

export default addAddressBookV2;
